import { Chip, Stack } from '@mui/material';
import type { ICellRendererParams } from 'ag-grid-community';

import CheckPermissions from '@/components/CheckPermissions';
import PERMISSIONS from '@/constants/auth.constants';
import { getStatusColor } from '@/pages/Administration/Devices/Devices.service';

import DEVICE_TYPES_CONFIG from '../DevicesTable.deviceTypes';
import type { AdminTreeDataRow } from '../utils/adminTreeData.utils';

/**
 * Cell renderer for source count column in admin devices view
 *
 * Displays a colored chip showing the count of sources for devices
 * that have source capability. Color indicates the aggregated source status.
 * Only visible to users with DEVICES_READ permission.
 * Skips rendering for group rows or devices without sources.
 *
 * @param props - AG Grid cell renderer params
 * @returns JSX element with source count chip or null
 */
const AdminDeviceSourceCountCellRenderer = (
  props: ICellRendererParams<AdminTreeDataRow>
) => {
  const { data } = props;

  if (!data || data.isGroupRow) {
    return null;
  }

  const deviceTypesConfig = DEVICE_TYPES_CONFIG.find(
    (item) => item.id === data.device_type_id
  );

  return (
    <Stack direction="row">
      {data.source_status !== undefined &&
        data.source_count !== undefined &&
        data.source_count > 0 &&
        deviceTypesConfig?.hasSource === 1 && (
          <CheckPermissions permissions={PERMISSIONS.DEVICES_READ}>
            <Chip
              label={`${data.source_count}`}
              variant="filled"
              color={getStatusColor(data.source_status)}
              size="small"
            />
          </CheckPermissions>
        )}
    </Stack>
  );
};

export default AdminDeviceSourceCountCellRenderer;
